module.exports = __webpack_public_path__ + "img/336.3b38b389.jpg";